import { FC, useEffect } from 'react';
import FileUploaderTile from '@views/AdminPage/ImportMedications/FileUploaderTile';
import FileUploader from '@views/AdminPage/ImportMedications/FileUploader/FileUploader';
import { EventType } from '@utils/eventBus';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { handleAdminImportSupplementsCleanUp } from '@store/features/adminImportMedications/actions';
import {
  adminImportSupplementsCleanUpListErrorsSelector,
  adminImportSupplementsCleanUpListLoadingSelector,
} from '@store/features/adminImportMedications/selectors';
import { removeAdminImportSupplementsCleanUpList } from '@store/features/adminImportMedications/slice';
import useDispatch from '@store/hooks/useDispatch';

const ImportSupplementsCleanUpList: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isLoadingCleanupList = useSelector(adminImportSupplementsCleanUpListLoadingSelector);
  const errorsCleanupList = useSelector(adminImportSupplementsCleanUpListErrorsSelector);
  const hasErrorsCleanupList = errorsCleanupList.length > 0;

  useEffect(() => {
    dispatch(removeAdminImportSupplementsCleanUpList());
  }, []);

  return (
    <FileUploaderTile title={t('admin.importCleanUpHeader')}>
      <FileUploader
        className="import-medications__file-uploader"
        importHandler={handleAdminImportSupplementsCleanUp}
        errors={errorsCleanupList}
        eventType={EventType.ADMIN_IMPORT_SUPPLEMENTS_CLEANUP_LIST_SUCCESS}
        hasErrors={hasErrorsCleanupList}
        isLoading={isLoadingCleanupList}
        successMessage={t('admin.importCleanUpSuccess')}
      />
    </FileUploaderTile>
  );
};

export default ImportSupplementsCleanUpList;
